import React, { useEffect } from 'react';
import GreenCheck from '../../../images/GreenCheck.svg'

import './Step.scss';

const Step = ({ currentStep, stepNumber, title, activeContent, inactiveContent=null, bgColor='white', bgColorInactive='#F4F5F6' }) => {
    useEffect(() => {
        if (document.querySelector('body') && document.querySelector('body').scrollTop) {
            document.querySelector('body').scrollTop = 0;
        }
    }, [currentStep]);

    return currentStep < stepNumber ? null :
    <div className='step-section-container' style={{backgroundColor: bgColor}}>
        <div className='step-section-title' style={{backgroundColor: currentStep === stepNumber ? bgColor : bgColorInactive}}>
            <div
              className="step-section-title-container"
              style={{
                color: currentStep === stepNumber ? '#3B4B59' : '#929BA3',
                fontWeight: currentStep === stepNumber ? 'bold' : 'lighter'
              }}>
                <div className="step-section-number">
                  Step {stepNumber}
                </div>
                <div>{title}</div>
            </div>
            {currentStep !== stepNumber ?
                <img src={GreenCheck} alt='green-check' id='green-check' />
            : null}
        </div>
        <div>
            {currentStep === stepNumber ? activeContent : inactiveContent}
        </div>
    </div>
};

export default Step;
